// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f0ac5953","453":"288c3d22","455":"11e230d0"}[chunkId] + ".chunk.js";
};